<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="120">
        </div>

        <div class="enter-membership-form">
                <div class="membership-input">
                    <div class="membership-number-text-field-label">
                    Membership number
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="membership-number-text-field">
                </div>

                <div class="membership-number-text-field-sub-label">
                    この番号は会員証に記載されています。
                </div>
            </div>
            
            <button type="button" @click="findMembership()" class="membership-number-submit">登録する</button>
        </div>
        
    </div>
</template>

<style scoped>
    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 100pt;
        object-fit: contain;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
    }
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 25pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 10pt;
        margin-bottom: 20pt;
    }

    .membership-number-submit {
    height: 40px;
    background-color: rgb(225, 228, 99);
    cursor: pointer;
    border: none;
    border-radius: 8px;
    color: black;
    font-family: SFPRoBold;
    font-size: 16px;
    transition: 300ms;
    width: 150pt
}

</style>


<script setup>
    import { store } from '../store.js'
    import { useRouter } from "vue-router";
    const router = useRouter();

    function findMembership() { 
        const membershipNumber = Number(document.getElementById("membership-number-text-field").value);
        store.updateMemberNumber(membershipNumber);

        switch (membershipNumber) {
            case 1:
                store.updateEmail("martinmaly66@hotmail.com")
                store.updateName("Martin Maly");
            break
            case 3:
                store.updateEmail("yonedayo1002@gmail.com")
                store.updateName("Kei Yoneura");
            break
            case 6:
                store.updateEmail("nori.masa@yahoo.com");
                store.updateName("Elena Doutou");
            break
            case 7:
                store.updateEmail("hikaru19980725@icloud.com");
                store.updateName("Hikaru Abe");
            break
            case 8:
                store.updateEmail("k.murakami@nosh.jp");
                store.updateName("Kiichi Murakami");
            break
            case 9:
                store.updateEmail("tatsuminjp@gmail.com");
                store.updateName("Takuya Tatsumi");
            break
            case 10:
                store.updateEmail("ryo.egu@gmail.com");
                store.updateName("Ryo Eguchi");
            break
            case 11:
                store.updateEmail("shiburuna@gmail.com");
                store.updateName("Runa Shibuya");
            break
            case 12:
                store.updateEmail("chkurokuro@gmail.com");
                store.updateName("Yuki Futagami");
            break
            case 13:
                store.updateEmail("ryujin0421@gmail.com");
                store.updateName("Ryujin Bigmountain Oyama");
            break
            case 14:
                store.updateEmail("drums-g36c@docomo.ne.jp");
                store.updateName("Takumi Usui");
            break
            case 15:
                store.updateEmail("kushidamiho@icloud.com");
                store.updateName("Miho Kushida");
            break
            case 16:
                store.updateEmail("nagakan819@gmail.com");
                store.updateName("Kan Nagai");
            break
            case 17:
                store.updateEmail("5508leontkhs@gmail.com");
                store.updateName("Mai Takahashi");
            break
            case 18:
                store.updateEmail("kurosame_9630@icloud.com");
                store.updateName("Satoshi Ninomiya");
            break
            case 19:
                store.updateEmail("yakinikuoishii39@gmail.com");
                store.updateName("Miku Kasahara");
            break
            case 20:
                store.updateEmail("innami@icloud.com");
                store.updateName("Toshimi Innami");
            break
            case 21:
                store.updateEmail("menoji.inv@gmail.com");
                store.updateName("Hajime Tsujisaka");
            break
            case 22:
                store.updateEmail("mahiro.nagasaki@gmail.com");
                store.updateName("Mahiro Nagasaki");
            break
            case 23:
                store.updateEmail("ryo9work@gmail.com");
                store.updateName("Ryo Kurihara");
            break
            case 24:
                store.updateEmail("etoybaseball@gmail.com");
                store.updateName("Yu Eto");
            break
            case 25:
                store.updateEmail("shunshun.43@gmail.com");
                store.updateName("Shunta Uehara");
            break
            case 26:
                store.updateEmail("varvaricialina@gmail.com");
                store.updateName("Alina Varvarici");
            break    
            default:
                alert("無効な会員番号");
            return
                  
        }

        router.push('/enter-password');
     } 
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>